import Http from '@/common/http'
export default class Register {
  static getVerify (param = {}) {
    return Http.post('/home/index/verify', param)
  }

    
  static saveInviteRegister (param = {}) {
    return Http.post('/home/no_auth/save_invite_register', param)
  }
  
  static getUserInfoByUid (param = {}) {
    return Http.post('/home/no_auth/get_user_info_by_uid', param)
  }
}
